export const roundNumber = (num?: number | null) =>
    num ? Math.round(num * 100) / 100 : 0
